import {Component, inject} from '@angular/core';
import {Card} from 'primeng/card';
import {NgOptimizedImage} from '@angular/common';
import {ActivatedRoute, Router} from '@angular/router';
import {Button} from 'primeng/button';
import {toSignal} from '@angular/core/rxjs-interop';
import {map} from 'rxjs/operators';
import {IconArrowLeftComponent} from '@components/icons/icon-arrow-left/icon-arrow-left.component';

@Component({
  selector: 'app-access-denied',
  imports: [
    Card,
    NgOptimizedImage,
    Button,
    IconArrowLeftComponent
  ],
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.css'
})
export class AccessDeniedComponent {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);

  protected readonly mensagem = toSignal(
    this.route.queryParamMap.pipe(map(p => p.get('mensagem'))),
    {initialValue: null}
  );

  goToHome() {
    this.router.navigate(['/']).then(() => console.log('Redirect to home'));
  }
}
